import { useRef } from "react";
import "../../../../../styles/panel/user/manageShop/shared/EditShopShared.css";

/* ---- آیکن‌ها ---- */
export const Icon = ({ children, className }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {children}
  </svg>
);

export const BACK_ICON = (
  <>
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </>
);
export const SEARCH_ICON = (
  <>
    <circle cx="11" cy="11" r="7" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </>
);
export const CHECK_ICON = <polyline points="20 6 9 17 4 12" />;
export const X_ICON = (
  <>
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </>
);
export const PLUS_ICON = (
  <>
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </>
);
export const TRASH_ICON = (
  <>
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <path d="M10 11v6" />
    <path d="M14 11v6" />
    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </>
);
export const IMAGE_ICON = (
  <>
    <rect x="3" y="3" width="18" height="18" rx="3" />
    <circle cx="8.5" cy="8.5" r="1.6" />
    <polyline points="21 15 16 10 5 21" />
  </>
);

export const HELP_ICON = (
  <>
    <circle cx="12" cy="12" r="10" />
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 2-3 4" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </>
);

export const CLOSE_ICON = (
  <>
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </>
);

export const FOLDER_ICON = (
  <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z" />
);

export const CHEVRON_ICON = <polyline points="6 9 12 15 18 9" />;

export const CHEVRON_LEFT = <polyline points="15 18 9 12 15 6" />;
export const CHEVRON_RIGHT = <polyline points="9 18 15 12 9 6" />;

export const UPLOAD_ICON = (
  <>
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="17 8 12 3 7 8" />
    <line x1="12" y1="3" x2="12" y2="15" />
  </>
);

export const STORE_ICON = (
  <>
    <path d="M3 9l1.5-5h15L21 9" />
    <path d="M4 9h16v10a1 1 0 01-1 1H5a1 1 0 01-1-1V9z" />
    <path d="M9 13a3 3 0 006 0" />
  </>
);

export const SPINNER_ICON = <path d="M21 12a9 9 0 1 1-6.219-8.56" />;

export const EMPTY_ICON = (
  <>
    <path d="M4 9h16v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9z" />
    <path d="M3 9l1.5-5h15L21 9" />
    <path d="M9 13a3 3 0 0 0 6 0" />
  </>
);

export const VIEW_ICON = (
  <>
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8Z" />
    <circle cx="12" cy="12" r="3" />
  </>
);

export const EDIT_ICON = (
  <>
    <path d="M12 20h9" />
    <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
  </>
);

export const SHOWCASE_ICON = (
  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
);

export const ATTACH_BTN = (
  <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
);

/* ---- منتقل‌شده از shopManage.shared.jsx (آیکن‌های صفحات مدیریت فروشگاه) ---- */
export const PAGES_ICON = (
  <>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <path d="M14 2v6h6" />
    <line x1="8" y1="13" x2="16" y2="13" />
    <line x1="8" y1="17" x2="16" y2="17" />
  </>
);
export const INFO_ICON = (
  <>
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="16" x2="12" y2="12" />
    <line x1="12" y1="8" x2="12.01" y2="8" />
  </>
);
export const CATEGORY_ICON = (
  <>
    <path d="M20.59 13.41 11 3.83A2 2 0 0 0 9.59 3.24L3 3v6.59a2 2 0 0 0 .59 1.41l9.58 9.58a2 2 0 0 0 2.82 0l4.6-4.6a2 2 0 0 0 0-2.82Z" />
    <circle cx="7.5" cy="7.5" r="1.5" fill="currentColor" stroke="none" />
  </>
);
export const CARD_ICON = (
  <>
    <rect x="2" y="5" width="20" height="14" rx="3" />
    <line x1="2" y1="10" x2="22" y2="10" />
    <line x1="6" y1="15" x2="10" y2="15" />
  </>
);
export const LINK_ICON = (
  <>
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
  </>
);
export const TRUST_ICON = (
  <>
    <path d="M12 2 4 5v6c0 5 3.4 8.7 8 11 4.6-2.3 8-6 8-11V5z" />
    <path d="m9 12 2 2 4-4" />
  </>
);
export const CALENDAR_ICON = (
  <>
    <rect x="3" y="4" width="18" height="18" rx="3" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </>
);
export const BELL_ICON = (
  <>
    <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
  </>
);
/* toggle-icons غیرتکراری: pages/info/category/card/link/trust/calendar/bell.
   showcase → SHOWCASE_ICON، products → STORE_ICON، chevron → CHEVRON_LEFT،
   search → SEARCH_ICON، help → HELP_ICON، close → CLOSE_ICON، arrowBack → BACK_ICON
   (همه از قبل در همین فایل موجودن، نیازی به تکرار نبود) */

export const uid = () =>
  typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : `id-${Date.now()}-${Math.random().toString(16).slice(2)}`;

/* ---- آپلود تصویر ---- */
export function ImageUpload({ value, onChange, className }) {
  const inputRef = useRef(null);

  const handleFile = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => onChange(reader.result);
    reader.readAsDataURL(file);
  };

  return (
    <div
      className={`esp-img-upload${className ? ` ${className}` : ""}`}
      onClick={() => inputRef.current?.click()}
      role="button"
      tabIndex={0}
    >
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        hidden
        onChange={handleFile}
      />
      {value ? (
        <img src={value} alt="" />
      ) : (
        <div className="esp-img-upload-empty">
          <Icon className="esp-img-upload-icon">{IMAGE_ICON}</Icon>
          <span>افزودن تصویر</span>
        </div>
      )}
    </div>
  );
}

/* ---- ردیف بنرهای تبلیغاتی (استفاده در تب صفحه اصلی و شبکه‌های اجتماعی) ---- */
export function BannerRow({
  title,
  hint,
  items,
  onAdd,
  onChange,
  onRemove,
  onConfirm,
  addLabel = "افزودن بنر",
  fieldLabel = "لینک بنر",
  fieldPlaceholder = "لینک صفحه‌ای که با کلیک روی بنر باز می‌شه",
  emptyHint = "هنوز بنری اضافه نکردی.",
}) {
  return (
    <div className="esp-section">
      <div className="esp-section-head">
        <h2>{title}</h2>
        {hint && <p>{hint}</p>}
      </div>

      {items.length === 0 && <p className="esp-empty-hint">{emptyHint}</p>}

      <div className="esp-banner-list">
        {items.map((item) => (
          <div className="esp-banner-item" key={item.id}>
            <ImageUpload
              className="esp-banner-thumb"
              value={item.image}
              onChange={(val) => onChange(item.id, "image", val)}
            />
            <div className="esp-banner-fields">
              <label>{fieldLabel}</label>
              <input
                type="text"
                value={item.link}
                onChange={(e) => onChange(item.id, "link", e.target.value)}
                placeholder={fieldPlaceholder}
              />
            </div>
            <div className="esp-icon-actions">
              <button
                type="button"
                className={`esp-icon-btn esp-icon-btn--check${
                  item.saved ? " esp-icon-btn--active" : ""
                }`}
                onClick={() => onConfirm(item.id)}
                title="ذخیره بنر"
              >
                <Icon>{CHECK_ICON}</Icon>
              </button>
              <button
                type="button"
                className="esp-icon-btn esp-icon-btn--remove"
                onClick={() => onRemove(item.id)}
                title="حذف بنر"
              >
                <Icon>{X_ICON}</Icon>
              </button>
            </div>
          </div>
        ))}
      </div>

      <button type="button" className="esp-add-line" onClick={onAdd}>
        <Icon>{PLUS_ICON}</Icon>
        {addLabel}
      </button>
    </div>
  );
}

// آیکن‌ها و ثابت‌های مشترک بین «لیست فروشگاه‌ها» و «صفحه مدیریت یک فروشگاه»
// این فایل رو کنار ManageShops.jsx و ManageShopDetail.jsx قرار بده
// خود آیکن‌ها (path/shape) به EditShopShared.jsx منتقل شدن؛ اینجا فقط ارجاع بهشون داده میشه

// export const Icon = ({ children, className }) => (
//   <svg
//     className={className}
//     viewBox="0 0 24 24"
//     fill="none"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     {children}
//   </svg>
// );

export const ICONS = {
  pages: PAGES_ICON,
  info: INFO_ICON,
  category: CATEGORY_ICON,
  products: STORE_ICON,
  showcase: SHOWCASE_ICON,
  card: CARD_ICON,
  link: LINK_ICON,
  trust: TRUST_ICON,
  help: HELP_ICON,
  close: CLOSE_ICON,
  calendar: CALENDAR_ICON,
  chevron: CHEVRON_LEFT,
  bell: BELL_ICON,
  search: SEARCH_ICON,
  // فلش «بازگشت» برای صفحه‌ی مدیریت یک فروشگاه (راست‌چین/RTL) — همون شکل BACK_ICON
  arrowBack: BACK_ICON,
};

// مسیر صفحه‌ی «سایت‌های من» برای تمدید اشتراک — اگر مسیر واقعی پروژه فرق داره، همینجا اصلاح کن
export const MY_SITES_PATH = "/panel/user/my-sites";

export const ACTIONS = [
  { id: "pages", label: "ویرایش صفحات", icon: "pages" },
  { id: "info", label: "اطلاعات اولیه", icon: "info" },
  { id: "products", label: "محصولات", icon: "products" },
  { id: "category", label: "دسته‌بندی", icon: "category" },
  { id: "showcase", label: "ویترین", icon: "showcase" },
  { id: "card", label: "شماره کارت", icon: "card" },
  { id: "trust", label: "نماد اعتماد", icon: "trust" },
];

export const GUIDE_STEPS = [
  {
    title: "دسته‌بندی و محصولات",
    text: "ابتدا دسته‌بندی‌ها رو بساز، بعد محصولاتت رو اضافه کن.",
  },
  {
    title: "مدیریت صفحات",
    text: "محتوای صفحات فروشگاهت (صفحه اصلی، درباره ما، تماس) رو تنظیم کن.",
  },
  {
    title: "اطلاعات اولیه",
    text: "آدرس، شماره، لوگو یا اسم فروشگاه رو از اینجا ویرایش کن.",
  },
  {
    title: "ویترین",
    text: "برای نمایش محصولات خاص در صفحه اول، ویترین بساز و محصولات رو بهش اضافه کن.",
  },
  {
    title: "شماره کارت",
    text: "شماره کارت و نام صاحب کارت فروشگاه رو ثبت کن تا پرداخت‌ها به حساب درست واریز بشه.",
  },
  {
    title: "نماد اعتماد",
    text: "لینک نماد اعتماد الکترونیکی فروشگاهت رو ثبت کن تا در صفحه فروشگاه نمایش داده بشه.",
  },
];

// آیا اشتراک فروشگاه هنوز معتبره؟
export const isActive = (shop, moment) => {
  if (!shop.end_date) return false;
  return moment(shop.end_date).isSameOrAfter(moment());
};
